import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LabelsPipe } from '../../shared/pipes/labels/labels.pipe';
import type { PalantirLabelColors } from '../../shared/pipes/labels/labels.type';
import { PalantirIconComponent } from '../icon/icon.component';
import { PalantirIcon } from '../icon/icon.type';

@Component({
  selector: 'palantir-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PalantirIconComponent, LabelsPipe],
})
export class PalantirTagComponent {
  public color = input.required<PalantirLabelColors>();

  public size = input<'base' | 'lg' | 'xs'>('base');

  public style = input<'bold' | 'soft'>('soft');

  public shape = input<'default' | 'rounded'>('rounded');

  public activatable = input<boolean>(false);

  public minified = input<boolean>(false);

  public prefix = input<PalantirIcon>();

  public suffix = input<PalantirIcon>();
}
